import React from 'react';
import { renderMarkdown } from '@karakuri-ai/react-render-markdown';
import { detectTable } from './detectTable';
import { renderSkill } from './Skill';
import { renderText } from './Text';
import { detectYoutube } from './youtube/youtube';
import { YoutubeIframe } from './youtube/YoutubeIframe';
export function render(content, skillApi, cardId) {
    var contentText = (content === null || content === void 0 ? void 0 : content.text) || '';
    if (content.contentFormat === 'markdown') {
        return React.createElement("div", { className: "md" }, renderMarkdown(contentText));
    }
    if (detectTable(contentText)) {
        return React.createElement("div", { className: "faq-answer-table md", dangerouslySetInnerHTML: { __html: contentText } });
    }
    if (detectYoutube(content)) {
        return React.createElement(YoutubeIframe, { youtubeId: content.meta.youtubeId });
    }
    var skill = renderSkill(skillApi, {
        from: 'FAQ_ANSWER',
        text: content.text,
        cardId: cardId,
        answerId: content.id,
    });
    if (skill) {
        return skill;
    }
    var text = contentText.endsWith('\n') ? contentText : contentText ? "".concat(content.text, "\n") : '';
    return renderText(text);
}
//# sourceMappingURL=render.js.map